export const PageText = {
  _1: 'Status',
  _2: 'The aircheckr team is constantly improving the aircheckr models, adding new features and expanding it to other areas.'
};

export const Categories = {
  _1: {
    title: 'Our models',
    subcategories: [
      {
        key: 0,
        subtitle: 'The quality of our models is primordial for us',
        text: 'Hence our models are never finished. We constantly try to improve the aircheckr models with the newest technologies and local data input. Moreover, we are working hard to extend the aircheckr portfolio and cover other countries as well. Follow <a href="/help-and-guides/airchecker-newsletter">our newsletter</a>, to stay up to date with our newest developments.'
      },
      {
        key: 1,
        subtitle: 'Models are by definition an estimation of reality',
        text: 'Hence they are not perfect. Local, unexpected air pollution cannot be “detected” immediately by aircheckr. If the area around your requested location has recently changed considerably (e.g. new circulation plan), it could be that aircheckr is less accurate for that location. But as the quality of our models means everything to us, we also work hard to provide you with a “confidence level” in each API response. If we are less confident that aircheckr is good for a specific location at a specific moment, you can be sure that we will let you know.'
      }
    ]
  },
  _2: {
    title: 'Our API',
    subcategories: [
      {
        key: 0,
        subtitle: 'We do our best to keep the aircheckr API fast and agile.',
        text: 'If you are experiencing a problem, email us at <a href="mailto:info@aircheckr.com" target="_top">info@aircheckr.com</a>.'
      }
    ]
  }
};

export default PageText;



// WEBPACK FOOTER //
// ./src/input-text/en/help-and-guides/status_page.js